<nav class="navbar navbar-vertical navbar-expand-md navbar-light bg-white" id="sidenav-main">
  <div class="container-fluid">
    <!-- Toggler -->
    <button class="navbar-toggler" type="button" (click)="isCollapsed=!isCollapsed"
      aria-controls="sidenav-collapse-main">
      <span class="navbar-toggler-icon"></span>
    </button>
    <!-- Brand -->
    <a class="navbar-brand pt-0" style="height: 20px !important;" routerLinkActive="active" [routerLink]="['/dashboard']">
      <img src="./assets/img/brand/logo.png" class="navbar-brand-img" alt="...">
    </a>
    <!-- User -->
    <ul class="nav align-items-center d-md-none">
      <li class="nav-item" ngbDropdown placement="bottom-right">
        <a class="nav-link" role="button" ngbDropdownToggle>
          <div class="media align-items-center">
            <span class="avatar avatar-sm rounded-circle">
              <img alt="Image placeholder" src="assets/img/default.png">
            </span>
          </div>
        </a>
        <div class="dropdown-menu-arrow dropdown-menu-right" ngbDropdownMenu>
          <a routerLinkActive="active" [routerLink]="['/user-profile']" class="dropdown-item">
            <i class="ni ni-single-02"></i>
            <span>Mon profil</span>
          </a>
          <div class="dropdown-divider"></div>
          <span class="dropdown-item" (click)="logout()" style="cursor: pointer;">
            <i class="ni ni-user-run"></i>
            <span>Déconnecter</span>
          </span>
        </div>
      </li>
    </ul>
    <!-- Collapse -->
    <div class="collapse navbar-collapse" [ngbCollapse]="isCollapsed" id="sidenav-collapse-main" *ngIf="!loading">
      <!-- Collapse header -->
      <div class="navbar-collapse-header d-md-none">
        <div class="row">
          <div class="col-6 collapse-brand">
            <a routerLinkActive="active" [routerLink]="['/dashboard']">
              <img src="./assets/img/brand/logo.png" class="navbar-brand-img">
            </a>
          </div>
          <div class="col-6 collapse-close">
            <button type="button" class="navbar-toggler" (click)="isCollapsed=!isCollapsed">
              <span></span>
              <span></span>
            </button>
          </div>
        </div>
      </div>

      <!-- Navigation -->
      <ul class="navbar-nav">
        <li *ngFor="let menuItem of menuItems" class="{{menuItem.class}} nav-item">
          <a routerLinkActive="active" [routerLink]="[menuItem.path]" class="nav-link"
            *ngIf="menuItem.subMenu.length == 0">
            <i class="ni {{menuItem.icon}}"></i>
            {{menuItem.title}} <span [innerHTML]="menuItem.concat_title"></span>
          </a>
          <div *ngIf="menuItem.subMenu.length > 0" class="nav-link">
            <i class="ni {{menuItem.icon}}"></i>
            {{menuItem.title}}
          </div>
          <div style="padding-left: 40px;padding-right: 10px;background-color: #f0f0f0;" *ngIf="menuItem.subMenu.length > 0">
            <a class="nav-link" style="display: block;" routerLinkActive="active" [routerLink]="[subMenuItem.path]"
              *ngFor="let subMenuItem of menuItem.subMenu">{{ subMenuItem.title }}</a>
          </div>
        </li>
      </ul>
      <hr class="my-3">
      <h6 class="navbar-heading text-muted">Pass Culture</h6>
      <ul class="navbar-nav">
        <li *ngFor="let menuItem of passcultureItems" class="{{menuItem.class}} nav-item">
          <a routerLinkActive="active" [routerLink]="[menuItem.path]" class="nav-link">
            <i class="ni {{menuItem.icon}}"></i>
            {{menuItem.title}}
          </a>
        </li>
      </ul>
      <hr class="my-3" *ngIf="menuBottomItems.length > 0">
      <h6 class="navbar-heading text-muted" *ngIf="menuBottomItems.length > 0">Administration</h6>
      <ul class="navbar-nav">
        <li *ngFor="let menuItem of menuBottomItems" class="{{menuItem.class}} nav-item">
          <a routerLinkActive="active" [routerLink]="[menuItem.path]" class="nav-link">
            <i class="ni {{menuItem.icon}}"></i>
            {{menuItem.title}} <span [innerHTML]="menuItem.concat_title"></span>
          </a>
        </li>
      </ul>
    </div>
  </div>
</nav>